import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Caption } from './TypographyComponent';

/*
Copyright Component
-------------------
Displays copyright notice at bottom of pages (except Projects listing page)
*/

function Copyright() {
  const location = useLocation();

  if (location.pathname === '/projects') {
    return null;
  }

  return (
    <Box sx={{ width: '100%', textAlign: 'left', py: 1, px: 1 }}>
      <Caption>©️ Nasir Abdirahman - {new Date().getFullYear()} All Rights Reserved </Caption>
    </Box>
  );
}

export default Copyright;
